const NETWORK_IP_KEY = 'crowdcam_network_ip';

export function getNetworkIP(): string | null {
  return localStorage.getItem(NETWORK_IP_KEY);
}

export function setNetworkIP(ip: string): void {
  localStorage.setItem(NETWORK_IP_KEY, ip);
}

export function getStreamUrl(eventId: string): string {
  const networkIP = getNetworkIP();

  if (networkIP && (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1')) {
    // Use network IP for QR codes when on localhost
    const protocol = window.location.protocol;
    const port = window.location.port ? `:${window.location.port}` : '';
    return `${protocol}//${networkIP}${port}/stream/${eventId}`;
  }

  return `${window.location.origin}/stream/${eventId}`;
}

export function promptForNetworkIP(): string | null {
  const currentIP = getNetworkIP();
  const ip = prompt(
    'Enter your local network IP for QR codes (e.g., 192.168.1.100):',
    currentIP || ''
  );

  if (ip) {
    setNetworkIP(ip);
  }

  return ip;
}
